// extracted by mini-css-extract-plugin
export default {"signUpMessage":"SignUpMessage_signUpMessage__PUH+r"};